module.exports = __webpack_public_path__ + "media/components/insights/safety-checks/icons/amber-icon-bd1ec5f560e6b5a715207e5704a5a39a.png";